import React from 'react';
import { ListItemIcon, ListItemText, MenuItem, Typography } from 'e100-react-components';
import { useStyles } from './styles';

interface NavigateItemProps {
  icon: React.JSX.Element;
  title?: string;
  selected?: boolean;
  onClick?: (e: MouseEvent) => void;
  id?: string;
  classes?: {
    iconRoot: string;
  };
}

export const NavigateItem = ({ icon, title, selected, onClick, classes, id } : NavigateItemProps) => {
  const classesInner = useStyles();

  return (
    <MenuItem
      disableGutters
      classes={{
        root: classesInner.container,
        selected: classesInner.selected,
      }}
      selected={selected}
      onClick={onClick}
      id={id}
    >
      <ListItemIcon
        classes={{
          root: `${classesInner.icon} ${classes?.iconRoot}`,
        }}
      >
        {icon}
      </ListItemIcon>
      {title && (
        <ListItemText>
          <Typography variant="caption">{title}</Typography>
        </ListItemText>
      )}
    </MenuItem>
  );
};
